import { CircleAlert } from 'lucide-react';
import { Alert, AlertTitle } from '@/components/ui/alert';

/** Blokkerende fout van de server boven een formulier (role="alert"). */
export function FormError({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <Alert variant="destructive">
      <CircleAlert aria-hidden="true" />
      <AlertTitle>{message}</AlertTitle>
    </Alert>
  );
}
